import axios from 'axios'
import endpoints from '@/api/endpoints'

export default {
  // budget categories
  async getCategories () {
    return axios.get(endpoints.budgetCategories).then((response) => {
      return response.data
    })
  },
  async createCategory (obj) {
    return axios.post(endpoints.budgetCategories, obj).then((response) => {
      return response.data
    })
  },
  async updateCategory (obj) {
    return axios.patch(endpoints.budgetCategories + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },

  // budgets
  async getBudgets () {
    return axios.get(endpoints.budgets).then((response) => {
      return response.data
    })
  },
  async getBudget (id) {
    return axios.get(endpoints.budgets + id + '/').then((response) => {
      return response.data
    })
  },
  async getActiveBudget () {
    // The "Current" budget is one whose start date is on or before today, and whose end date is on or after today.
    return axios.get(endpoints.budgets + '?is_active=true').then((response) => {
      return response.data.length > 0 ? response.data[0] : []
    })
  },
  async getActiveBudgetLineItems () {
    // The "Current" budget is one whose start date is on or before today, and whose end date is on or after today.
    return axios.get(endpoints.budgetLineItems + '?budget__is_active=true').then((response) => {
      return response.data
    })
  },
  async createBudget (obj) {
    return axios.post(endpoints.budgets, obj).then((response) => {
      return response.data
    })
  },
  async updateBudget (obj) {
    return axios.patch(endpoints.budgets + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  // budget line items
  async getBudgetLineItems (budgetID) {
    return axios.get(endpoints.budgetLineItems + '?budget=' + budgetID).then((response) => {
      return response.data
    })
  },
  async getBudgetLineItem (id) {
    return axios.get(endpoints.budgetLineItems + id + '/').then((response) => {
      return response.data
    })
  },
  async createBudgetLineItem (obj) {
    return axios.post(endpoints.budgetLineItems, obj).then((response) => {
      return response.data
    })
  },
  async updateBudgetLineItem (obj) {
    return axios.patch(endpoints.budgetLineItems + obj.id + '/', obj).then((response) => {
      return response.data
    })
  }
}